import { CancelTokenSource } from 'axios';
import { useCallback, useRef } from 'react';
import { createCancelTokenSource } from './pricingData.service';

function useCancelableRequest(): <T>(
  fn: (token: CancelTokenSource) => Promise<T>,
) => Promise<T> {
  const tokenRef = useRef<CancelTokenSource | null>(null);
  const runWithCancel = useCallback(
    async <T>(fn: (token: CancelTokenSource) => Promise<T>) => {
      tokenRef.current?.cancel();
      tokenRef.current = createCancelTokenSource();
      return fn(tokenRef.current);
    },
    [],
  );
  return runWithCancel;
}

export default useCancelableRequest;
